import Vue from "vue";

// action types
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const UPDATE_ACCOUNT_INFO = "updateUserAccountInfo";

// mutation types
export const SET_PERSONAL_INFO = "setPersonalInfo";
export const SET_ACCOUNT_INFO = "setAccountInfo";

const state = {
  user_personal_info: localStorage.getItem("user"),
  user_account_info: {}
};

const getters = {
  currentUserPersonalInfo(state) {
    // Nunca nulo: o modulo nasce com localStorage vazio e so ganha corpo
    // quando a autenticacao despacha o usuario. Entre um e outro, o Header,
    // o Menu e o Aside leem propriedades daqui no primeiro render, e com
    // null a tela estourava em tres erros distintos de uma vez
    // (null.cliente, null.mostrarSqlRunner, null.novosMenus).
    return state.user_personal_info || {};
  },

  currentUserAccountInfo(state) {
    return state.user_account_info;
  },

  currentUserPhoto(state) {
    return state.user_personal_info.photo;
  },

  // WEL-5192: bloqueio de tela pessoal (lock screen via TOTP).
  telaBloqueada(state) {
    return state.user_personal_info?.tela_bloqueada || false;
  }
};

const actions = {
  [UPDATE_PERSONAL_INFO](context, payload) {
    context.commit(SET_PERSONAL_INFO, payload);
  },
  [UPDATE_ACCOUNT_INFO](context, payload) {
    context.commit(SET_ACCOUNT_INFO, payload);
  }
};

const mutations = {
  [SET_PERSONAL_INFO](state, user_personal_info) {
    state.user_personal_info = user_personal_info;
  },
  [SET_ACCOUNT_INFO](state, user_account_info) {
    state.user_account_info = user_account_info;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
